import { List } from 'immutable';

export function getProgressReport(state) {
  return state.get('rootReducer').get('progressReports');
}

/**
 * Concatenates non-empty `summary` strings from a progress report's `units`
 * (GET /groups/:groupId/unit-reports payload).
 */
export function getCombinedUnitSummariesText(progressReport) {
  if (! progressReport) {
    return '';
  }

  let rawUnits;
  if (progressReport.get && typeof progressReport.get === 'function') {
    rawUnits = progressReport.get('units');
  } else {
    rawUnits = progressReport.units;
  }

  if (! rawUnits) {
    return '';
  }

  let unitsArray;
  if (List.isList(rawUnits)) {
    unitsArray = rawUnits.toArray();
  } else if (Array.isArray(rawUnits)) {
    unitsArray = rawUnits;
  } else {
    unitsArray = [];
  }

  return unitsArray
    .map((unit) => {
      if (! unit) {
        return '';
      }
      let summary;
      if (unit.get && typeof unit.get === 'function') {
        summary = unit.get('summary');
      } else {
        summary = unit.summary;
      }
      return summary && String(summary).trim();
    })
    .filter((s) => s)
    .join('\n\n');
}

export function getProgressReportById(state, id) {
  return getProgressReport(state) && getProgressReport(state).get(id);
}

export function getProgressReportIdBySessionId(state, sessionId) {
  const sessionPlans = state.get('rootReducer').get('sessionPlans');
  let progressReports = state.get('rootReducer').get('progressReports');
  const { unitIds } = sessionPlans.get(sessionId);
  progressReports = progressReports.filter((progressReport) =>
    progressReport.units.reduce((isCurrentPR, unit) =>
        (unitIds.includes(`${unit.get('id')}`) || isCurrentPR), false));
  return progressReports.map((pr) => pr.id);
}



// WEBPACK FOOTER //
// ./data/ProgressReports/accessors.js